import { GameSchema } from "@fapinstructor/common";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { fapinstructorApi } from "../../api";

export const GAME_QUERY_KEY = "games";

export function getGameQueryKey({ gameId }: GetGameParams) {
  return [GAME_QUERY_KEY, "detail", gameId];
}

type GetGameParams = {
  gameId: string;
};

async function getGame(params: GetGameParams) {
  return await fapinstructorApi.get(`/game/${params.gameId}`).json(GameSchema);
}

export function useGame(params: GetGameParams) {
  const query = useQuery(gameQueryOptions(params));
  return query;
}

export const gameQueryOptions = (params: GetGameParams) =>
  queryOptions({
    queryKey: getGameQueryKey(params),
    queryFn: () => getGame(params),
    // TODO: Currently the initialValues for the form doesn't update while fetching in the background.
    gcTime: 0,
    throwOnError: true,
  });
